import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';
import React from 'react';

interface TimeClockIconProps {
  color?: string;
  altColor?: string;
  style?: React.CSSProperties;
}

export const TimeClockIcon = ({
  color = RoutalPalette.neutral02,
  altColor = RoutalPalette.neutral40,
  style = {},
  ...props
}: TimeClockIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 17 17" style={{ width: `17px`, height: `17px`, fill: `none`, ...style }}>
      <path
        d="M8.50021 15.6616C12.2873 15.6616 15.3574 12.5915 15.3574 8.80441C15.3574 5.01731 12.2873 1.94727 8.50021 1.94727C4.71311 1.94727 1.64307 5.01731 1.64307 8.80441C1.64307 12.5915 4.71311 15.6616 8.50021 15.6616Z"
        fill={color}
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M8.5 4.68945V8.80374L11.2429 10.1752" stroke={altColor} strokeLinecap="round" strokeLinejoin="round" />
    </SvgIcon>
  );
};
